import { Directive, Input, OnDestroy, OnInit, Optional, Self } from '@angular/core';
import { FormControlName } from '@angular/forms';
import { L10nTranslationService } from 'angular-l10n';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

/** Prefix for translation keys of error messages */
const validationMessagePrefix = 'ERROR_';

/**
 * Object to override error messages
 * Key: The error type to override
 * Value: The new message
 */
export interface CustomErrors {
	[errorname: string]: string;
}

/** Name of error used to catch all undefined messages */
const catchAllErrorName = 'ERROR_CATCH_ALL';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[as-validator]',
    standalone: true,
})
export class AsValidatorDirective implements OnInit, OnDestroy {
	/** Object to override the error messages */
	// tslint:disable-next-line:no-input-rename
	@Input('as-validator')
	customErrors: CustomErrors = {};

	/** Used for cleanup */
	private destroy$ = new Subject<void>();

	/**
	 * Constructor
	 */
	constructor(@Self() @Optional() private control: FormControlName, private translationService: L10nTranslationService) {
		if (control == null) {
			throw new Error('NodeInjector: NOT_FOUND [FormControlName] -- AS: [as-validator] expects a [formControlName] to be set.');
		}
	}

	/**
	 * Initialization
	 */
	ngOnInit() {
		const va: any = this.control.valueAccessor;
		// if (dxTypes.findIndex(i => i === vaType) > -1) {
		if (va.noDataText !== null && va.onContentReady != null) {
			// ok, it's an dx control, get a handle to it's instance
			const widgetInstance = va.instance;
			this.control.control.statusChanges.pipe(takeUntil(this.destroy$)).subscribe(_ => {
				if (!this.control.dirty) {
					return;
				}
				if (this.control.invalid) {
					// Handle the error case, get the messages

					const validationErrors = Object.keys(this.control.errors).map(errorKey => {
						const errorId = validationMessagePrefix + errorKey.toUpperCase();
						// fetch the error message for the custom provided error.
						const errorMessage =
							this.customErrors[errorId] ||
							this.customErrors[catchAllErrorName] ||
							this.translationService.translate(errorId) ||
							errorId;

						return {
							message: errorMessage,
						};
					});

					setTimeout(() => {
						widgetInstance.option({
							isValid: this.control.valid,
							validationErrors: validationErrors,
						});
					}, 10);
				} else {
					widgetInstance.option({ isValid: true });
				}
			});
		}
	}

	/**
	 * Cleanup
	 */
	ngOnDestroy() {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
